import { useState, type FormEvent } from "react";
import { categories } from "@/mocks/categories";

interface NewsFilterProps {
  activeCategory: string;
  keyword: string;
  total: number;
  onSelectCategory: (slug: string) => void;
  onSubmitKeyword: (value: string) => void;
}

export default function NewsFilter({
  activeCategory,
  keyword,
  total,
  onSelectCategory,
  onSubmitKeyword,
}: NewsFilterProps) {
  const [draft, setDraft] = useState(keyword);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmitKeyword(draft.trim());
  };

  const tabs = [{ slug: "all", name: "全部" }, ...categories];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center gap-2">
        {tabs.map((tab) => {
          const isActive = activeCategory === tab.slug;
          return (
            <button
              key={tab.slug}
              type="button"
              onClick={() => onSelectCategory(tab.slug)}
              className="whitespace-nowrap rounded-full px-1 py-1"
              aria-pressed={isActive}
            >
              <span
                className={`block rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                }`}
              >
                {tab.name}
              </span>
            </button>
          );
        })}
      </div>

      <div className="mt-4 flex flex-col gap-3 border-t border-background-200 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-foreground-600">
          共找到 <span className="font-medium text-primary-600">{total}</span> 篇瓜料
          {keyword && <span className="ml-2 text-foreground-500">关键词：「{keyword}」</span>}
        </p>
        <form onSubmit={handleSubmit} className="flex items-center gap-2">
          <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2 focus-within:border-primary-400 sm:flex-none">
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true" />
            <input
              type="search"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              placeholder="搜索瓜料 / 标签"
              aria-label="在瓜料列表内搜索"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none sm:w-44"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-foreground-900 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-foreground-800"
          >
            搜索
          </button>
        </form>
      </div>
    </div>
  );
}